import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import AdminDetails from 'components/Admins/AdminDetails';
import apiClient from 'apiClient';
import dataMapper from 'pages/Admins/dataMappers/details';
import { AdminDetails as Details } from 'store/admins/types';

type DetailProps = {
  match: {
    params: {
      id: string;
    };
  };
};

const AdminsDetails: React.FC<RouteComponentProps & DetailProps> = ({
  match,
  history,
}: RouteComponentProps & DetailProps) => {
  const [error, setError] = useState<string>('');
  const [isSaved, setIsSaved] = useState<boolean>(false);
  const adminId = match.params.id;
  const [adminDetails, setAdminDetails] = useState<Details>({
    address: { buildingNumber: '', buildingName: '', city: '', county: '', street: '', postcode: '' },
    company: '',
    contactNumber: '',
    email: '',
    fcaNumber: '',
    firstName: '',
    id: 0,
    isVerified: false,
    lastName: '',
    lmcRefNumber: null,
  });

  useEffect(() => {
    let shouldCancel = false;

    const getAdmin = async () => {
      const res = await apiClient.get(`/api/v1/broker-management/admins/${adminId}`);
      if (!shouldCancel) setAdminDetails(dataMapper.mapForView(res.data));
    };

    getAdmin();

    return () => {
      shouldCancel = true;
    };
  }, [adminId]);

  const handleSubmit = async (values: Details) => {
    const data = dataMapper.mapForSave(values);
    apiClient
      .post(`/api/v1/broker-management/update-admin/${values.id}`, data)
      .then(() => setIsSaved(true))
      .catch(() => {
        setIsSaved(false);
        setError('Could not save.');
      });
  };

  return (
    <>
      <AdminDetails
        details={adminDetails}
        error={error}
        onSubmit={handleSubmit}
        onBack={history.goBack}
        isSaved={isSaved}
      />
    </>
  );
};

export default AdminsDetails;
